module.exports = __webpack_public_path__ + "assets/images/data-extracts.649245f89b00c49c314fe81c7f5775bf.svg";